import { IHG_CARDS } from "@card-data/cards/chase/ihg";
import { INK_CARDS } from "@card-data/cards/chase/ink";
import { CHASE_MARRIOTT_CARDS } from "@card-data/cards/chase/marriott";
import { SAPPHIRE_CARDS } from "@card-data/cards/chase/sapphire";
import { SOUTHWEST_CARDS } from "@card-data/cards/chase/southwest";
import { UNITED_CARDS } from "@card-data/cards/chase/united";
import { CREDITS } from "@card-data/credits";
import { schemas } from "@card-data/generated/api.client";
import { REFERRALS } from "@card-data/referral-links";
import { CreditCardInput } from "@card-data/types";
import { WEIGHTS } from "@card-data/weights";

export const CHASE_CARDS: Array<CreditCardInput> = [
  ...CHASE_MARRIOTT_CARDS,
  ...SOUTHWEST_CARDS,
  ...UNITED_CARDS,
  ...INK_CARDS,
  ...IHG_CARDS,
  ...SAPPHIRE_CARDS,
  {
    cardId: "dcafcac45d86331a7f6b9cfdb980b81e",
    name: "Aer Lingus Signature",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.AVIOS,
    isBusiness: false,
    annualFee: 95,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.chase.com/travel-credit-cards/avios/aer-lingus",
    imageUrl: "/images/chase/aer-lingus-signature.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 100_000 }],
        spend: 7500,
        days: 180,
        credits: [],
        expiration: "2024-12-31",
      },
    ],
  },
  {
    cardId: "7662e34a89a906b869b93bb12a2e1b3b",
    name: "Aeroplan",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.AEROPLAN,
    isBusiness: false,
    annualFee: 195,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.chase.com/travel-credit-cards/aircanada/aeroplan",
    imageUrl: "/images/chase/aeroplan.jpg",
    credits: [
      {
        value: 100,
        description: "Air Canada Credit",
        weight: WEIGHTS.TRAVEL_CREDIT_LOYALTY_PROGRAM_SPECIFIC,
      },
      CREDITS.PRECHECK_OR_SIMILAR,
    ],
    offers: [
      {
        amount: [{ amount: 115_000 }],
        spend: 20_000,
        days: 365,
        credits: [],
        details: "75k @ $4k/90d, +40k @ $20k total/12mo.",
        expiration: "2026-11-18",
      },
      {
        amount: [{ amount: 75_000 }],
        spend: 4000,
        days: 90,
        credits: [],
        details: "75k @ $4k/90d, +40k @ $20k total/12mo.",
        expiration: "2026-11-18",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 100_000 }],
        spend: 20_000,
        days: 365,
        credits: [],
        details: "75k @ $4k/90d, +25k @ $20k total/12mo.",
        expiration: "2026-09-03",
      },
      {
        amount: [{ amount: 75_000 }],
        spend: 4000,
        days: 90,
        credits: [],
        details: "75k @ $4k/90d, +25k @ $20k total/12mo.",
        expiration: "2026-09-03",
      },
      {
        amount: [{ amount: 85_000 }],
        spend: 4000,
        days: 90,
        credits: [],
        expiration: "2026-08-04",
      },
      {
        amount: [{ amount: 60_000 }],
        spend: 4000,
        days: 90,
        credits: [],
        expiration: "2026-03-21",
      },
      {
        amount: [{ amount: 100_000 }],
        credits: [],
        spend: 3000,
        days: 90,
        expiration: "2024-10-01",
      },
    ],
  },
  {
    cardId: "7b06f0b6a307509b71862ffa5933ef0b",
    name: "British Airways Signature",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.AVIOS,
    isBusiness: false,
    annualFee: 95,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.chase.com/travel-credit-cards/avios/british-airways",
    imageUrl: "/images/chase/british-airways.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 90_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2026-09-21",
      },
      {
        amount: [{ amount: 90_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2026-05-27",
      },
      {
        amount: [{ amount: 75_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2026-03-21",
      },
      {
        amount: [{ amount: 100_000 }],
        spend: 7500,
        days: 180,
        credits: [],
        expiration: "2024-12-31",
      },
    ],
  },
  {
    cardId: "cd81837eb0aedd4752197e044e77381a",
    name: "Disney Premier",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 49,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.chase.com/rewards-credit-cards/disney/premier",
    imageUrl: "/images/chase/disney.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 300 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 400 }],
        credits: [],
        spend: 1000,
        days: 90,
      },
    ],
  },
  {
    cardId: "12a1578aeb5bfcdd3bc794154ad1f6cc",
    name: "Disney",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.chase.com/rewards-credit-cards/disney/rewards",
    imageUrl: "/images/chase/disney.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 150 }],
        spend: 500,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 200 }],
        spend: 500,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "6ba7f561f6a4f7f2934bec25bd9a3130",
    name: "Freedom Flex",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.CHASE,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.chase.com/cash-back-credit-cards/freedom/flex",
    imageUrl: "/images/chase/freedom-flex.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 25_000 }],
        spend: 500,
        days: 90,
        credits: [],
      },
      {
        amount: [{ amount: 20_000 }],
        spend: 500,
        days: 90,
        credits: [],
        url: REFERRALS.CHASE.FREEDOM,
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 20_000 }],
        credits: [],
        spend: 500,
        days: 90,
      },
    ],
  },
  {
    cardId: "e3bd814087bf696d651ddab50ddcaaa7",
    name: "Freedom Rise",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.CHASE,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.5,
    url: "https://creditcards.chase.com/cash-back-credit-cards/freedom/rise",
    imageUrl: "/images/chase/freedom-rise.png",
    details:
      "Credit-builder card. Also has a non-guaranteed limited-time 3% dining cash back (vs. standard 1.5%) on up to $6k spend in first 6mo, worth up to ~$90 extra — not captured in the structured offer amount.",
    credits: [],
    offers: [
      {
        amount: [{ amount: 25 }],
        spend: 0.01,
        days: 90,
        credits: [],
        details:
          "$25 statement credit for enrolling in automatic payments within first 3mo; must stay enrolled 90+ days.",
      },
    ],
    historicalOffers: [],
  },
  {
    cardId: "3a9ea798ce73485fc8456280fd4b1816",
    name: "Freedom Unlimited",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.CHASE,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.5,
    url: "https://creditcards.chase.com/cash-back-credit-cards/freedom/unlimited",
    imageUrl: "/images/chase/freedom-unlimited.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 25_000 }],
        spend: 500,
        days: 90,
        credits: [],
        referralUrl: REFERRALS.CHASE.FREEDOM,
      },
      {
        amount: [{ amount: 20_000 }],
        spend: 500,
        days: 90,
        credits: [],
        referralUrl: REFERRALS.CHASE.FREEDOM,
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 30_000 }],
        spend: 500,
        days: 90,
        credits: [],
        expiration: "2026-03-21",
      },
      {
        amount: [{ amount: 25_000 }],
        credits: [],
        spend: 500,
        days: 90,
      },
    ],
  },
  {
    cardId: "60c2e7b4bc2e526bf38dac5be5f4433c",
    name: "Iberia Signature",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.AVIOS,
    isBusiness: false,
    annualFee: 95,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.chase.com/travel-credit-cards/avios/iberia",
    imageUrl: "/images/chase/iberia-signature.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 90_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2026-09-21",
      },
      {
        amount: [{ amount: 100_000 }],
        spend: 7500,
        days: 180,
        credits: [],
        expiration: "2024-12-31",
      },
    ],
  },
  {
    cardId: "d378a38b56d4c9bd5e1ad184a6ce84f0",
    name: "World of Hyatt",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.HYATT,
    isBusiness: false,
    annualFee: 95,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.chase.com/travel-credit-cards/world-of-hyatt-credit-card", // easier to scrape than direct Hyatt page
    imageUrl: "/images/chase/world-of-hyatt.png",
    credits: [],
    offers: [
      {
        amount: [
          {
            amount: 45_000,
          },
        ],
        spend: 5000,
        days: 90,
        credits: [],
        details:
          "Additional up to 30k via 2x points on up to $15k spend in first 6mo (not guaranteed).",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 30_000 }],
        spend: 3000,
        days: 90,
        credits: [],
      },
      {
        amount: [{ amount: 0 }],
        spend: 3000,
        days: 90,
        credits: [
          {
            value: 3 * 30_000,
            description: "3x FNC, <= 30k per.",
            weight: WEIGHTS.FREE_NIGHT_CREDIT,
            currency: schemas.CurrenciesEnum.enum.HYATT,
          },
        ],
        expiration: "2026-02-26",
      },
      {
        amount: [],
        spend: 3000,
        days: 90,
        credits: [
          {
            value: 90_000,
            description: "3x FNC, <= 30k per.",
            weight: WEIGHTS.FREE_NIGHT_CREDIT,
            currency: schemas.CurrenciesEnum.enum.HYATT,
          },
        ],
        expiration: "2024-10-31",
      },
    ],
  },
  {
    cardId: "0d9d833e7298ab0f1892a4035686fa06",
    name: "World of Hyatt Business",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.HYATT,
    isBusiness: false,
    annualFee: 199,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.chase.com/business-credit-cards/world-of-hyatt/hyatt-business-card", // easier to scrape than direct Hyatt page
    imageUrl: "/images/chase/world-of-hyatt.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 70_000 }],
        spend: 7000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 60_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2026-07-25",
      },
      {
        amount: [{ amount: 80_000 }],
        spend: 10_000,
        days: 90,
        credits: [],
        expiration: "2026-04-30",
      },
      {
        amount: [{ amount: 60_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2026-03-21",
      },
      {
        amount: [{ amount: 60_000 }],
        spend: 3000,
        days: 90,
        credits: [],
        url: "https://creditcards.chase.com/worldofhyatt/22/naepb",
      },
      {
        amount: [{ amount: 75_000 }],
        spend: 12000,
        days: 180,
        credits: [],
        url: "https://creditcards.chase.com/worldofhyatt/22/naepb",
      },
    ],
  },
  {
    cardId: "f4d8c429f58f9f74944a9108bcae4a22",
    name: "Amazon Prime",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.amazon.com/dp/BT00LN946S",
    imageUrl: "/images/chase/amazon-prime.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 150 }],
        spend: 0.01,
        days: 365,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 200 }],
        spend: 0.01,
        days: 90,
        credits: [],
        details: "No spend requirement — instant bonus upon approval.",
        expiration: "2026-07-09",
      },
      {
        amount: [{ amount: 250 }],
        spend: 0.01,
        days: 365,
        credits: [],
        expiration: "2025-11-10",
      },
    ],
  },
];
